import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  selectLoadTagsError,
  selectTagCreationState,
  selectTags,
} from './tags.selectors';

@Injectable({ providedIn: 'root' })
export class TagsSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly tags = this._store.selectSignal(selectTags);

  public readonly loadTagsError = this._store.selectSignal(selectLoadTagsError);

  public readonly tagCreationState = this._store.selectSignal(
    selectTagCreationState,
  );
}
